module.exports = __webpack_public_path__ + "img/socksGame1new.c1b89a09.png";